import api, { unwrap } from './client';

// ── Company time year (paramètres entreprise par année) ──────────────────────

export const listCompanyTimeYears = (tenantId) =>
  unwrap(api.get(`/hr/company-time/${tenantId}`));

export const getCompanyTimeYear = (tenantId, year) =>
  unwrap(api.get(`/hr/company-time/${tenantId}/${year}`));

export const createCompanyTimeYear = (tenantId, payload) =>
  unwrap(api.post(`/hr/company-time/${tenantId}`, payload));

export const updateCompanyTimeYear = (tenantId, year, payload) =>
  unwrap(api.patch(`/hr/company-time/${tenantId}/${year}`, payload));

export const deleteCompanyTimeYear = (tenantId, year) =>
  unwrap(api.delete(`/hr/company-time/${tenantId}/${year}`));

export const copyCompanyTimeYear = (tenantId, fromYear, toYear, overwrite = false) =>
  unwrap(api.post(`/hr/company-time/${tenantId}/copy-year`, {
    from_year: fromYear, to_year: toYear, overwrite,
  }));

// ── Public holidays ──────────────────────────────────────────────────────────

export const getHolidayProposals = (canton, year) =>
  unwrap(api.get(`/hr/public-holidays/proposals`, { params: { canton, year } }));

export const bulkSetCantonalHolidays = (tenantId, year, items) =>
  unwrap(api.post(`/hr/public-holidays/${tenantId}/${year}/bulk`, { items }));

export const addManualHoliday = (tenantId, year, payload) =>
  unwrap(api.post(`/hr/public-holidays/${tenantId}/${year}`, payload));

export const updateHoliday = (tenantId, holidayId, payload) =>
  unwrap(api.patch(`/hr/public-holidays/${tenantId}/${holidayId}`, payload));

export const deleteHoliday = (tenantId, holidayId) =>
  unwrap(api.delete(`/hr/public-holidays/${tenantId}/${holidayId}`));

// ── Saisies mensuelles (rattrapages + mémo) ──────────────────────────────────

export const upsertMonth = (tenantId, year, month, payload) =>
  unwrap(api.patch(`/hr/company-time/${tenantId}/${year}/months/${month}`, payload));

// ── Tenant canton (helper) ───────────────────────────────────────────────────

export const updateTenantCanton = (tenantId, canton) =>
  unwrap(api.patch(`/tenants/${tenantId}`, { canton_code: canton }));

// Liste des cantons romands supportés (statique côté frontend, miroir backend)
export const ROMAND_CANTONS = [
  { code: 'GE', name: 'Genève' },
  { code: 'VD', name: 'Vaud' },
  { code: 'VS', name: 'Valais' },
  { code: 'FR', name: 'Fribourg' },
  { code: 'NE', name: 'Neuchâtel' },
  { code: 'JU', name: 'Jura' },
  { code: 'BE', name: 'Berne (Jura bernois)' },
];

export const MONTH_LABELS = [
  'Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.',
];

// Jour semaine compact FR (Lundi → 'LU', Mardi → 'MA', etc.)
export const WEEKDAY_LABELS_FR = ['LU', 'MA', 'ME', 'JE', 'VE', 'SA', 'DI'];

// Catégories de "fériés et congés"
export const HOLIDAY_KINDS = [
  { value: 'official',    label: 'Férié officiel',    short: 'férié.',        color: '#666' },
  { value: 'offered',     label: 'Congé offert',      short: 'congé offert',  color: '#1f6f49' },
  { value: 'compensated', label: 'Congé rattrapé',    short: 'congé rattr.',  color: '#c45d3e' },
];
export const KIND_BY_VALUE = Object.fromEntries(HOLIDAY_KINDS.map(k => [k.value, k]));
